import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Pricing from "@/components/Pricing";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatbotWidget from "@/components/ChatbotWidget";
import TechDivider from "@/components/TechDivider";

export default function Home() {
  return (
    <main className="relative bg-nova-bg" data-testid="home-page">
      <Hero />
      <Services />
      <TechDivider variant="gold" label="/// PROCESS · LIVE" />
      <Process />
      <Pricing />
      <TechDivider variant="cyan" label="/// CONTACT · SECURE CHANNEL" />
      <About />
      <FAQ />
      <Contact />
      <Footer />
      <ChatbotWidget />
    </main>
  );
}
